import { Key } from './engine/enums';
import { Renderable } from './engine/renderable';
import Vector2d from './engine/vector2d';
import { TILE_SIZE } from './maze';
import State from './state';
import TextRenderer, { Color, FontSize } from './text';

const CHARACTERS = [' ', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];

export enum InputState {
  Disabled,
  Pending,
  Done
}

export default class TextInput implements Renderable<State> {

  public get name() {
    return `textInput`;
  }

  private cursor: number = 0;
  private characters: string[] = [' '];
  private textRenderer?: TextRenderer;
  private pos: Vector2d;

  private _inputState: InputState = InputState.Disabled;

  public get inputState() {
    return this._inputState;
  }

  constructor(textRenderer: TextRenderer, pos: Vector2d, private onDone: (str: String) => void, inputState: InputState = InputState.Disabled) {
    this.textRenderer = textRenderer;
    this.pos = pos;
    this._inputState = inputState;
  }

  move(key: Key) {
    if (this.inputState !== InputState.Pending) {
      return;
    }

    let index = CHARACTERS.indexOf(this.characters[this.cursor] || ' ');

    switch (key) {
      case Key.Down:
        index -= 1;
        if (index < 0) {
          index = CHARACTERS.length - 1;
        }
        this.characters[this.cursor] = CHARACTERS[index % CHARACTERS.length];
        break;
        case Key.Up:
        index += 1;
        if (index < 0) {
          index = CHARACTERS.length - 1;
        }
        this.characters[this.cursor] = CHARACTERS[index % CHARACTERS.length];
        break;
      case Key.Left:
        if (this.cursor > 0)
          this.cursor--;
        break;
      case Key.Right:
        if (this.cursor < 9) {
          if (this.characters[this.cursor] === ' ') {
            this._inputState = InputState.Done;
            this.onDone(this.characters.join('').trim());
          } else {
            this.cursor++;
            if (!this.characters[this.cursor]) {
              this.characters[this.cursor] = ' ';
            }
          }
        } else {
          this._inputState = InputState.Done;
          this.onDone(this.characters.join('').trim());
        }
    }
  }

  update(gameTime: number, state: State): void {
  }

  render(gameTime: number, ctx: CanvasRenderingContext2D): void {
    ctx.save();

    Array.from({ length: 10 }).forEach((_, i) => {
      const char = this.characters[i];
      if (char) {
        if (i === this.cursor && gameTime % 30 < 15 && this.inputState === InputState.Pending) {
          ctx.fillStyle = '#fff';
          ctx.fillRect(this.pos.x * TILE_SIZE + (16 * i), this.pos.y * TILE_SIZE + TILE_SIZE, 14, 4);
        }
        this.textRenderer?.renderText(char, FontSize.Normal, Color.White, new Vector2d(this.pos.x + i, this.pos.y), ctx);
      }
    });

    ctx.restore();
  }
}
